module.exports = __webpack_public_path__ + "static/Kyber-1757254f2b1bc05d8f909af54ddc129a.svg";